var app = angular.module("leonardo");

var OnDemandInstructionActions = function($scope, $state, PermissionService) {
  $scope.permissionService = PermissionService;
};

app.controller('OnDemandInstructionActions', ['$scope', '$state', 'PermissionService', OnDemandInstructionActions]);
